<template>
  <div>
    <Header
      :temSelecionados="selecionados.length > 0"
      :selecionados="selecionados"
      @update:filtros="(e) => handleFiltros(e)"
      @upload:concluido="handleUploadConcluido"
      @search:change="val => termo_pesquisa = val"
    />

    <Tabela
      ref="tabelaMixProdutos"
      :selected="selecionados"
      :filtros="filtros"
      :termo_pesquisa="termo_pesquisa"
      @update:selecionados="(e) => handleSelecionados(e)"
    />
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';

import Header from '@/components/MixProdutosFilial/Header.vue';
import Tabela from '@/components/MixProdutosFilial/Tabela.vue';

const tabelaMixProdutos = ref(null);
const termo_pesquisa = ref('');

const selecionados = ref([]);
const filtros = ref({
  filiais: [],
  fornecedores: [],
  segmentos: [],
  secoes: [],
  categorias: [],
  curva_popularidade: [],
  curva_financeira: [],
  possui_venda: [],
  movimentacao: [],
  pertence_ao_mix: [],
  produtos_combinados: false,
  produtos_nao_combinados: true,
  produtos_ativos: true,
  produtos_inativos: false,
  produtos_estoque_zero: false
});

function handleSelecionados(e) {
  selecionados.value = e;
}

function handleFiltros(e) {
  filtros.value = e;
}

async function handleUploadConcluido() {
  await nextTick();
  const t = tabelaMixProdutos.value;

  if (t && typeof t.buscarProdutos === 'function') {
    t.buscarProdutos();
  }

  selecionados.value = [];
}

</script>
